<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Schulden voor de eigen woning
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Met 'eigenwoningschulden' bedoelen we een lening voor de aankoop, het onderhoud of de verbouwing van je
                eigen woning. Het gaat dus niet om een lening voor de financiering van je tweede woning (bijvoorbeeld
                een vakantiewoning) of andere onroerende zaken.
                <div class="space10"></div>

                Je kunt ook een eigenwoningschuld hebben bij een schuld voor een aanhorigheid of bij het vruchtgebruik
                van een woning die je geërfd hebt en de kosten en rente van de schuld op de woning voor jouw rekening
                komen.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Bijzondere situaties m.b.t. eigenwoningschulden
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Er kan ook sprake zijn van eigenwoningschulden en aftrekbare rente en financieringskosten in de volgende
                situaties:
                <li class="list">je bent verhuisd. Je oude woning stond leeg en was nog niet verkocht.</li>
                <li class="list">je hebt een woning gekocht die was bedoeld als je toekomstige hoofdverblijf. Deze woning stond leeg
                    of was nog in aanbouw.
                <li class="list">je bent verhuisd en je vroegere fiscale partner bleef in de woning wonen.</li>
                <li class="list">je was opgenomen in een verzorgings- of verpleeghuis. Je hield je eigen woning aan.</li>
                <li class="list">je woning stond tijdelijk leeg, bijvoorbeeld omdat je was overgeplaatst of uitgezonden.</li>
                <div class="space10"></div>

                Meer hierover vind je bij de hieronder vermelde 'Meer fiscale informatie'.

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading13">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse13"
                    aria-expanded="false" aria-controls="collapse13">
                Welke rente en kosten zijn aftrekbaar?
            </button>
        </h2>
        <div id="collapse13" class="accordion-collapse collapse" aria-labelledby="heading13"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als er sprake is van een eigenwoningschuld dan kunnen de rente en financieringskosten aftrekbaar zijn.
                Het gaat om de volgende kosten:
                <li class="list">(hypotheek)rente. Vul de rente in bij dit onderdeel 'Eigenwoningschulden'.</li>
                <li class="list">financieringskosten. Vul de financieringskosten in bij het onderdeel 'Financieringskosten'</li>
                <li class="list">periodieke betalingen voor erfpacht, opstal of beklemming. Vul de betalingen in bij het onderdeel
                    'Woningen'.</li>
                <div class="space10"></div>

                Heb je weinig of geen aftrekbare kosten voor de eigen woning? Dan heb je misschien recht op de aftrek
                vanwege geen of een kleine eigenwoningschuld. Deze wordt door ons automatisch berekend.
                <div class="space10"></div>

                Je mag misschien de rente en kosten aftrekken in de volgende situaties:
                <li class="list">je hebt geld geleend voor onderhoud of verbouwing van de eigen woning maar het geld nog niet
                    hiervoor gebruikt.</li>
                <li class="list">je lening staat op een aparte rekening die speciaal is geopend voor onderhoud of verbouwing (een
                    verbouwingsdepot).</li>
                <li class="list">je lening staat op een aparte rekening die speciaal is geopend voor de bouw van de woning (een
                    nieuwbouwdepot).</li>
                <li class="list">je hebt in {{ this.year }} rente vooruitbetaald voor een periode tot 1 juli {{ this.year + 1 }}.
                </li>
                <div class="space10"></div>

                Meer hierover vind je bij de hieronder vermelde 'Meer fiscale informatie'.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3"
                    aria-expanded="false" aria-controls="collapse3">
                Betaalde rente in {{ this.year }}
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul bij deze vraag de totale rente die aangever in {{ this.year }} heeft betaald over de
                (hypotheek)schuld. Tel bij dit bedrag ook mee:
                <li class="list">rente over de lening voor de afkoop van rechten van erfpacht, opstal of beklemming</li>
                <li class="list">de boeterente.</li>
                <li class="list">de (hypotheek)rente die aangever in {{ this.year }} vooruitbetaalde voor een periode tot uiterlijk
                    30 juni {{ this.year + 1 }}.</li>
                <div class="space10"></div>

                <b>Vooruitbetaalde rente</b><br/>
                Betaalde aangever in {{ this.year }} (hypotheek)rente vooruit voor een periode niet langer dan tot en
                met 30 juni {{ this.year + 1 }}? Dan is dit bedrag helemaal aftrekbaar in {{ this.year }}.
                <div class="space10"></div>

                Betaalde aangever in {{ this.year }} (hypotheek)rente vooruit voor een periode tot na 30
                juni {{ this.year + 1 }}? Dan is dit bedrag in{{ this.year }} niet helemaal aftrekbaar. Aangever mag dan
                over {{ this.year }} alleen de (hypotheek)rente aftrekken die betrekking heeft op {{ this.year }}. Het
                resterende deel trekt aangever in gelijke delen af over de andere jaren waarvoor aangever de rente
                vooruitbetaalt.
                <div class="space10"></div>

                Betaalde aangever bijvoorbeeld rente over de periode 1 augustus {{ this.year }} tot 1
                augustus {{ this.year + 2 }}, dan is de rente over de periode 1 januari {{ this.year + 1 }} tot en met
                31 juli {{ this.year + 2 }} in gelijke delen aftrekbaar in {{ this.year + 1 }} en {{ this.year + 2 }}.
                <div class="space10"></div>

                <b>Teruggekregen rente</b><br/>
                Heeft aangever in {{ this.year }} (hypotheek)rente teruggekregen? Dan moet aangever deze verrekenen met
                de betaalde rente. <br/>Is het teruggekregen bedrag hoger dan de rente die aangever in {{ this.year }} heeft
                betaald? Vul dan hier een negatief bedrag in.
            </div>
        </div>
    </div>
</div>
